// 权限管理路由
const general: any = [
    {
        path: 'log/log',
        name: 'sdk_log_list',
        meta: {
            pathTitle: 'sdk_log_list',
            title: '推送日志'
        },
        component: () => import('@/views/log/log.vue')
    },
]
export default general
